module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/gUe0WK/tc-custom/9781427862983.jpg?1729082774010",
      "alt": "This image is the cover for the book Dogby Walks Alone, Volume 2, Dogby Walks Alone"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Dogby Walks Alone, Volume 2, Dogby Walks Alone\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_vm._v("A theme park mascot’s adventures continue as he tries to save a small town overrun by a strange cult in this humorous mystery manga.")])]), _c('p', [_vm._v(" After the harrowing incident at Happyplace, Dogby, battered and alone, heads up north. Collapsing from the cold and exhaustion, he’s brought in by a single mother and her son in desperate need of a father figure. However, things aren’t exactly normal in this town, which is being taken over by a cult. If Dogby’s going to take on legions of disciples, he might have to call in for some extra help, straight from Hollywood. ")]), _c('p', [_c('b', [_vm._v("Praise for "), _c('i', [_vm._v("Dogby Walks Alone, Vol. 1")])])]), _c('b', [_vm._v("“[Abbott] has a pedigree, solid chops on almost every aspect of producing a comic book, and has now produced one of the best OEL manga to come out this year in "), _c('i', [_vm._v("Dogby Walks Alone")]), _vm._v(". . . . I'd love to let you in on some of the jokes that had me laughing out loud, but you're better off finding them on your own.” —IGN.com")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Wes Abbott\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Tokyopop Verlag\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 71
// module chunks = 0